import * as HttpService from './http.service';
import { GET_BILL_RATE } from './url.service';

// eslint-disable-next-line import/prefer-default-export
export const getBillRate = ({
    functionCode,
    serviceAreaCode,
    subServiceAreaCode,
    designation,
    startDate,
    skillGroup,
    cecStatus,
    employmentType,
    subSubFunctionCode
}) => HttpService.getWithAuth(GET_BILL_RATE({
    functionCode,
    serviceAreaCode,
    subServiceAreaCode,
    designation,
    startDate,
    skillGroup,
    cecStatus,
    employmentType,
    subSubFunctionCode
}));
